import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import ArrowRight from '../../common/Icons/Arrow-Right.svg';
import ArrowRightHighlighted from '../../common/Icons/Arrow-Right-Highlighted.svg';
import HoverIcon from '../gridcomponents/HoverIcon';

const createDetailsColumn = (getRowLink) => ({
    id: 'Grid/Virtual/Details',
    title: '',
    width: 30,
    renderCell: (row) => (
        <Link to={ getRowLink(row) }>
            <div role="none" className={ row.gridProps.styles['icon-cell-wrapper'] }>
                <HoverIcon icon={ ArrowRight } hoverIcon={ ArrowRightHighlighted } styles={ row.gridProps.styles } />
            </div>
        </Link>
    ),
    columnSpacing: 0,
    noPadding: true
});

const withDetails = (Component) => {
    const WrappedComponent = (props) => {
        const {
            columns, singleClickRowLink, doubleClickRowLink, getRowLink
        } = props;
        const memoizedColumns = useMemo(
            () => (
                getRowLink && !(singleClickRowLink || doubleClickRowLink)
                    ? [...columns, createDetailsColumn(getRowLink)]
                    : columns
            ),
            [getRowLink, columns, singleClickRowLink, doubleClickRowLink]
        );
        return (<Component { ...props } columns={ memoizedColumns } />);
    };

    WrappedComponent.propTypes = {
        columns: PropTypes.arrayOf(PropTypes.shape({})),
        singleClickRowLink: PropTypes.bool,
        doubleClickRowLink: PropTypes.bool,
        getRowLink: PropTypes.func
    };

    WrappedComponent.defaultProps = {
        columns: [],
        singleClickRowLink: false,
        doubleClickRowLink: false,
        getRowLink: undefined
    };

    return WrappedComponent;
};

export default withDetails;
